import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Outlet, useLocation } from "react-router-dom";

export const Layout = () => {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase();

  const shouldHideFooter = [
    "/login",
    "/myregistration",
    "/verify",
    "/register",
  ].includes(path);
  const shouldHideNavbar = false;

  return (
    <div className="flex flex-col min-h-screen">
      {!shouldHideNavbar && (
        <div className="z-10 w-full flex justify-center">
          <Navbar />
        </div>
      )}

      <div className="w-full flex justify-center">
        <Header />
      </div>

      <main className="flex-grow">
        <Outlet />
      </main>

      {!shouldHideFooter && (
        <div className="w-full">
          <Footer />
        </div>
      )}
    </div>
  );
};
